/** better-auth's own cookie prefix; a worktree's localhost API replaces it. */
export const AUTH_COOKIE_BASE_PREFIX = "better-auth";

/**
 * The prefix of the staff API's auth cookies, which the native app also reads
 * its stored session token by. A browser accepts a `__Host-` cookie only from
 * the host that set it, with no Domain and Path=/, so no other `*.vidimo.app`
 * host can plant or shadow the session. It needs HTTPS.
 */
export function authCookiePrefix(
  isHttps: boolean,
  base: string = AUTH_COOKIE_BASE_PREFIX
): string {
  return isHttps ? `__Host-${base}` : base;
}

/**
 * What every guest-pool cookie prefix ends in, keeping it apart from the staff
 * pool's on a localhost jar both share. The portal forwards only these.
 */
export const GUEST_COOKIE_PREFIX_SUFFIX = "-guest";
